export const UPDATE_BANNER = /* GraphQL */ `
  mutation UpdateBanner($input: BannerInput!) {
    updateBanner(input: $input) {
      id
      contentHead
      contentDescription
      contentBtn
      video
      image
      overlayColor
      btnUrl
      position
      imageBackgroundSize
      imageBackgroundPosition
      createdAt
      updatedAt
    }
  }
`